import initialState from './initialState';
import * as types from '../constants/actionTypes';

export default (state = initialState.memberTypePluralReducer, action) => {
  const { payload } = action;

  switch (action.type) {
    case types.GET_MEMBER_TYPE_PLURAL_REQUEST:
      return state.set('isLoading', true);
    case types.GET_MEMBER_TYPE_PLURAL_FAILURE:
      return state.set('isLoading', false).set('isError', true);
    case types.GET_MEMBER_TYPE_PLURAL_SUCCESS:
      return state.set('isLoading', false).set('isError', false).set('isAlreadyGetSuccess', true).set('items', payload.items);
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.memberTypePluralReducer;
      return state;
    }
    default:
      return state;
  }
};
